import OrderStatuses from '../enum/OrderStatuses';
import {
  GET_ORDERS_PAGE_COUNT,
  GET_SET_COMPANY,
  GET_SET_ORDERS,
  GET_SET_ORDERS_PAGE,
  GET_SET_ORDERS_V2,
  GET_SET_ORDER_V2
} from '../utils/api';
import { getData, postData, putData, delData } from '../utils/api-service';
import WashdayClientSingleton from './WashdayClientSingleton';
import { PaymentMethodsEnum } from '../enum/PaymentMethodsEnum';
import { OrderDTO } from '../pages/NewOrder/interfaces';
import type {
  CreateReturnOrderDto,
  IUpdateOrderLineAssignmentsDto,
  IOrderStoreTransferPreviewRequest,
  IOrderStoreTransferRequest,
  ResendOrderNotificationRequest
} from 'washday-sdk';

export const setOrderCleaningBySequence = async (orderSequence, storeID, t = () => { }) => {
  try {
    storeID = typeof storeID === 'string' ? storeID : storeID._id;
    const updateObj = {
      status: OrderStatuses.CLEANING
    };
    const res = await putData(
      `${GET_SET_ORDERS}/${orderSequence}/${storeID}/cleaning`,
      updateObj,
      null,
      t('alerts.success'),
      t
    );
    if (res.status < 400 && res?.data?.errors?.length) {
      //it created the order but returned an error
      alert(res.data.errors[0]);
    }
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const setOrderCancelledBySequence = async (orderSequence, storeID, t = () => { }) => {
  try {
    storeID = typeof storeID === 'string' ? storeID : storeID._id;
    const currDate = new Date().toISOString();
    const updateObj = {
      cancelledDateTime: currDate
    };
    const res = await putData(
      `${GET_SET_ORDERS}/${orderSequence}/${storeID}/cancelled`,
      updateObj,
      null,
      t('alerts.success'),
      t
    );
    if (res.status < 400 && res?.data?.errors?.length) {
      //it created the order but returned an error
      alert(res.data.errors[0]);
    }
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const setOrderCleanedBySequence = async (orderSequence, storeID, t = () => { }) => {
  try {
    storeID = typeof storeID === 'string' ? storeID : storeID._id;
    const currDate = new Date().toISOString();
    const updateObj = {
      cleanedDateTime: currDate,
      readyDateTime: currDate
    };
    const res = await putData(
      `${GET_SET_ORDERS}/${orderSequence}/${storeID}/cleaned`,
      updateObj,
      null,
      t('alerts.success'),
      t
    );
    if (res.status < 400 && res?.data?.errors?.length) {
      //it created the order but returned an error
      alert(res.data.errors[0]);
    }
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const setOrderCollectedBySequence = async (
  orderSequence,
  storeID,
  t = () => { },
  showAlert = true
) => {
  try {
    storeID = typeof storeID === 'string' ? storeID : storeID._id;
    const currDate = new Date().toISOString();
    const updateObj = {
      collectedDateTime: currDate
    };
    const res = await putData(
      `${GET_SET_ORDERS}/${orderSequence}/${storeID}/collected`,
      updateObj,
      null,
      t('alerts.success'),
      t,
      showAlert
    );
    if (res.status < 400 && res?.data?.errors?.length) {
      //it created the order but returned an error
      alert(res.data.errors[0]);
    }
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const setOrderPickingBySequence = async (orderSequence, storeID, t = () => { }) => {
  try {
    storeID = typeof storeID === 'string' ? storeID : storeID._id;
    const updateObj = {
      pickingUpDateTime: new Date().toISOString()
    };

    const res = await putData(
      `${GET_SET_ORDERS}/${orderSequence}/${storeID}/picking`,
      updateObj,
      null,
      t('alerts.success'),
      t
    );
    if (res.status < 400 && res?.data?.errors?.length) {
      //it created the order but returned an error
      alert(res.data.errors[0]);
    }
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const setOrderDeliveringBySequence = async (orderSequence, storeID, t = () => { }) => {
  try {
    storeID = typeof storeID === 'string' ? storeID : storeID._id;
    const updateObj = {
      deliveringDateTime: new Date().toISOString()
    };

    const res = await putData(
      `${GET_SET_ORDERS}/${orderSequence}/${storeID}/delivering`,
      updateObj,
      null,
      t('alerts.success'),
      t
    );
    if (res.status < 400 && res?.data?.errors?.length) {
      //it created the order but returned an error
      alert(res.data.errors[0]);
    }
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const setOrderDeliveredBySequence = async (orderSequence, storeID, t = () => { }) => {
  try {
    storeID = typeof storeID === 'string' ? storeID : storeID._id;
    const updateObj = {
      collectedDateTime: new Date().toISOString()
    };

    const res = await putData(
      `${GET_SET_ORDERS}/${orderSequence}/${storeID}/delivered`,
      updateObj,
      null,
      t('alerts.success'),
      t
    );
    if (res.status < 400 && res?.data?.errors?.length) {
      //it created the order but returned an error
      alert(res.data.errors[0]);
    }
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const createPaymentLineByOrderId = async (orderID: string, data: {
  amountPaid: Number,
  paymentMethod: string,
  cashierBox: string,
}, t = () => { }) => {
  try {
    if (!orderID) return;
    const postObj = {
      amountPaid: data.amountPaid,
      paymentMethod: data.paymentMethod,
      cashierBox: data.cashierBox,
      paymentDate: new Date().toISOString()
    };

    const res = await postData(
      `api/v2/order/${orderID}/paymentLines`,
      postObj,
      null,
      t('alerts.success'),
      'application/json',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const createNewOrder = async (orderRequestObj, t = () => { }) => {
  try {
    const res = await postData(GET_SET_ORDERS, orderRequestObj, null, t('alerts.success'), null, t);
    if (!res) {
      throw new Error('Error al enviar, contacte a soporte tecnico');
    }
    if (res.status < 400 && res?.data?.errors?.length) {
      //it created the order but returned an error
      alert(res.data.errors[0]);
    }
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const fetchOrdersByDateRangeAndStore = async (query = '', t = () => { }) => {
  try {
    const res = await getData(`${GET_SET_ORDERS_V2}/cfdiPreview?${query}`, null, t);
    return res.data?.data || [];
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico', e);
    return [];
  }
};

export const getCompanyByID = async (companyID = '', t = () => { }) => {
  try {
    const res = await getData(`${GET_SET_COMPANY}/${companyID}`, null, t);
    return res.data?.data || {};
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico', e);
    throw e;
  }
};

export const getOrderById = async (orderId) => {
  try {
    const res = await getData(`api/v2/order/${orderId}`);
    if (!res?.data?.data) {
      throw 'No se encontro pedido';
    }
    return res.data.data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const updateOrderByID = async (orderID, order, t = () => { }) => {
  try {
    const res = await putData(
      `api/v2/order/${orderID}`,
      { ...order, updatedDate: new Date().toISOString() },
      null,
      t('alerts.success'),
      t
    );

    if (!res) {
      throw new Error('No pudimos actualizar el registro');
    }
    return res.data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const updatePaymentLine = async (orderID, paymentLineID, data, t = () => { }) => {
  try {
    const res = await putData(
      `${GET_SET_ORDER_V2}/${orderID}/paymentLines/${paymentLineID}`,
      data,
      null,
      t('alerts.success'),
      t
    );
    if (res.status < 400 && res?.data?.errors?.length) {
      //it created the order but returned an error
      alert(res.data.errors[0]);
    }
    return res?.data?.data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const deletePaymentLineById = async (orderID, paymentLineID, t = () => { }) => {
  try {
    const res = await delData(
      `${GET_SET_ORDER_V2}/${orderID}/paymentLines/${paymentLineID}`,
      null,
      null,
      t('alerts.success'),
      t
    );
    return res?.data?.data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const getOrdersList = async (queryParam) => {
  try {
    const ordersData = await getData(`${GET_SET_ORDERS_PAGE}${queryParam && `?${queryParam}`}`);
    const orders = ordersData?.data?.data?.orders || [];
    return { orders };
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const getOrdersListTotalCount = async (queryParam) => {
  try {
    const ordersCount = await getData(`${GET_ORDERS_PAGE_COUNT}${queryParam && `?${queryParam}`}`);
    const totalRowsCount = ordersCount.data?.data?.totalRows || 0;
    return { totalRowsCount };
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

//#region ORDERS ENDPOINTS V2
export const getOrdersListV2 = async (params: {
  storeId?: string,
  storeIds?: string[] | string,
  status?: string,
  name?: string,
  phone?: string,
  email?: string,
  fromDate?: string,
  toDate?: string,
  sequence?: string,
  pageNum?: number,
  limit?: number,
  sequenceSort: string,
  cleanedDateTime?: string,
  readyDateTime?: string,
  collectedDateTime?: string,
  collectedDateTimeMode?: "storeDay",
  delivery?: boolean | "true" | "false",
  activeOnly?: boolean | "true" | "false",
  q?: string,
  pickupFromDate?: string,
  pickupToDate?: string,
  deliveryFromDate?: string,
  deliveryToDate?: string,
  fetchSection?: string,
  cfdiId?: string,
  customerId?: string,
  assignedEmployee?: string,
  includeAmountDueTotal?: boolean | string,
  signal?: AbortSignal
}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries({
        ...params,
        includeAmountDueTotal: params.includeAmountDueTotal ?? false
      }).filter(([_, value]) => value !== undefined)
    );
    return await WashdayClientSingleton.getInstance().orders.getList(filteredParams);
  } catch (e) {
    console.log('ERROR getOrdersListV2', e);
    throw e;
  }
};

export const getOrdersForCFDIV2 = async (params: {
  fromDate: string
  toDate: string
  storeID?: string
  storeIds?: string[]
  includeAllStores?: boolean
  customerID?: string
}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    return await WashdayClientSingleton.getInstance().orders.fetchOrdersForCFDI(filteredParams);
  } catch (e) {
    console.log('ERROR fetchOrdersForCFDIV2', e);
    throw e;
  }
};

export const createPaymentLineByOrderIdV2 = async (orderId: string, data: {
  amountPaid: number,
  cashierBox: string,
  paymentMethod: string
  paymentDate: string
  pinUserId?: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.createPaymentLine(orderId, data);
  } catch (e) {
    console.log('ERROR createPaymentLineByOrderIdV2', e);
    throw e;
  }
};

export const updatePaymentLineByIdV2 = async (orderId: string, id: string, data: {
  amountPaid: number
  paymentMethod?: PaymentMethodsEnum.Cash | PaymentMethodsEnum.Card | PaymentMethodsEnum.Transfer
  updatedDate: Date
  pinUserId?: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.updatePaymentLineById(orderId, id, data);
  } catch (e) {
    console.log('ERROR updatePaymentLineById', e);
    throw e;
  }
};


export const sendEmailReceipt = async (orderId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.sendEmailReceipt(orderId);
  } catch (e) {
    console.log('ERROR sendEmailReceipt', e);
    throw e;
  }
};

export const deletePaymentLineByIdV2 = async (orderId: string, id: string) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.deletePaymentLineById(orderId, id);
  } catch (e) {
    console.log('ERROR updatePaymentLineById', e);
    throw e;
  }
};

export const deleteOrderEvidence = async (orderId: string, evidenceId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.deleteOrderEvidence(orderId, evidenceId);
  } catch (e) {
    console.log('ERROR deleteOrderEvidence', e);
    throw e;
  }
};

export const payAndCollect = async (payload: {
  orderId?: string;
  sequence: string;
  storeId: string;
  paymentMethod: string;
  cashierBoxId?: string;
  amount?: number;
  paymentDate?: string | Date;
  collectedDateTime?: string | Date;
  collectWithAmountDue?: boolean;
  pinValidationToken?: string;
  pinUserId?: string;
  attemptId?: string;
  expectedStatus?: 'ready';
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.payAndCollect(payload);
  } catch (e) {
    throw e;
  }
};

export const exportOrdersListV2 = async (params: {
  storeId?: string,
  status?: string,
  name?: string,
  phone?: string,
  email?: string,
  fromDate?: string,
  toDate?: string,
  sequence?: string,
  pageNum?: number,
  limit?: number,
  sequenceSort?: string,
  cleanedDateTime?: string,
  readyDateTime?: string,
  collectedDateTime?: string,
  q?: string,
  assignedEmployee?: string
}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );

    return await WashdayClientSingleton.getInstance().csv.exportOrdersList(filteredParams);
  } catch (e) {
    console.log('ERROR exportOrdersListV2', e);
    throw e;
  }
};

export const setOrderCancelledBySequenceV2 = async (sequence: string, storeId: string, data: {
  orderId?: string
  cancelledDateTime: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.setOrderCancelledBySequence(sequence, storeId, data);
  } catch (e) {
    console.log('ERROR setOrderCancelledBySequence', e);
    throw e;
  }
};

export const setOrderCleaningBySequenceV2 = async (sequence: string, storeId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.setOrderCleaningBySequence(sequence, storeId);
  } catch (e) {
    console.log('ERROR setOrderCleaningBySequence', e);
    throw e;
  }
};
export const setOrderCleanedBySequenceV2 = async (sequence: string, storeId: string, data: {
  cleanedDateTime: string,
  readyDateTime: string
}, params?: {
  markOutsourcedAsReturned?: boolean
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.setOrderCleanedBySequence(sequence, storeId, data, params);
  } catch (e) {
    console.log('ERROR setOrderCleanedBySequence', e);
    throw e;
  }
};

export const setOrderCollectedBySequenceV2 = async (sequence: string, storeId: string, data: {
  collectedDateTime: string
  collectWithAmountDue?: boolean
  orderId?: string
  expectedStatus?: 'ready'
  pinValidationToken?: string
  pinUserId?: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.setOrderCollectedBySequence(sequence, storeId, data);
  } catch (e) {
    throw e;
  }
};

export const setOrdePickingBySequenceV2 = async (sequence: string, storeId: string, data: {
  pickingUpDateTime: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.setOrdePickingBySequence(sequence, storeId, data);
  } catch (e) {
    console.log('ERROR setOrdePickingBySequence', e);
    throw e;
  }
};

export const setOrdeDeliveringBySequenceV2 = async (sequence: string, storeId: string, data: {
  deliveringDateTime: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.setOrdeDeliveringBySequence(sequence, storeId, data);
  } catch (e) {
    console.log('ERROR setOrdeDeliveringBySequence', e);
    throw e;
  }
};

export const setOrdeDeliveredBySequenceV2 = async (sequence: string, storeId: string, data: {
  collectedDateTime: string
  collectWithAmountDue?: boolean
  pinUserId?: string
  pinValidationToken?: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.setOrdeDeliveredBySequence(sequence, storeId, data);
  } catch (e) {
    throw e;
  }
};

export const getOrdersHeaderSummaryV2 = async (params: {
  store?: string,
  status?: string
}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );

    return await WashdayClientSingleton.getInstance().orders.getOrdersHeaderSummary(filteredParams);
  } catch (e) {
    console.log('ERROR getOrdersListV2', e);
    throw e;
  }
};
export const setOrderAcceptedBySequenceV2 = async (sequence: string, storeId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.setOrderAcceptedBySequence(sequence, storeId);
  } catch (e) {
    console.log('ERROR setOrderAcceptedBySequenceV2', e);
    throw e;
  }
};

export const getRequestedOrdersSummary = async (storeIds: string) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.getRequestedOrdersSummary(storeIds);
  } catch (e) {
    console.log('ERROR getRequestedOrdersSummary', e);
    throw e;
  }
};

export const bulkSetOrderCancelled = async (storeId: string, data: {
  ordersIds: string[];
  cancelledDateTime: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.bulkCancel(storeId, data);
  } catch (e) {
    console.log('ERROR bulkSetOrderCancelled', e);
    throw e;
  }
};

export const bulkSetOrderClean = async (storeId: string, data: {
  ordersIds: string[];
  cleanedDateTime: string;
  readyDateTime: string;
}, params?: {
  markOutsourcedAsReturned?: boolean
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.bulkClean(storeId, data, params);
  } catch (e) {
    console.log('ERROR bulkSetOrderClean', e);
    throw e;
  }
};

export const bulkSetOrderCollect = async (storeId: string, data: {
  pinUserId?: string;
  pinValidationToken?: string;
  collectWithAmountDue?: boolean;
  ordersIds: string[];
  collectedDateTime: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.bulkCollect(storeId, data);
  } catch (e) {
    throw e;
  }
};

export const bulkCreatePaymentLines = async (storeId: string, data: {
  paymentLines: {
    sequence: string;
    orderId: string
    paymentMethod: PaymentMethodsEnum
    amount: number;
    cashierBoxId: string;
    paymentDate: Date;
    pinUserId?: string
  }[],
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.bulkCreatePaymentLines(storeId, data);
  } catch (e) {
    console.log('ERROR bulkCreatePaymentLines', e);
    throw e;
  }
};

export const createOrderUsersApp = async (data: OrderDTO) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.createOrderUsersApp({
      ...data,
      createdChannel: 'pos_web',
    });
  } catch (e) {
    console.log('ERROR createOrderUsersApp', e);
    throw e;
  }
};

export const getOrderByIdV2 = async (orderId: string, params?: {
  fetchSection?: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.getById(orderId, params);
  } catch (e) {
    console.log('ERROR getOrderByIdV2', e);
    throw e;
  }
};

export const createOperationalReturnOrder = async (
  sourceOrderId: string,
  data: CreateReturnOrderDto
) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.createReturnOrder(sourceOrderId, data);
  } catch (e) {
    console.log('ERROR createOperationalReturnOrder', e);
    throw e;
  }
};

export const getOperationalReturnOrders = async (sourceOrderId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.getReturnOrders(sourceOrderId);
  } catch (e) {
    console.log('ERROR getOperationalReturnOrders', e);
    throw e;
  }
};

export const previewOrderStoreTransfer = async (
  orderId: string,
  data: IOrderStoreTransferPreviewRequest
) => WashdayClientSingleton.getInstance().orders.previewStoreTransfer(orderId, data);

export const transferOrderStore = async (
  orderId: string,
  data: IOrderStoreTransferRequest
) => WashdayClientSingleton.getInstance().orders.transferStore(orderId, data);

export const updateOrderLineAssignments = (
  orderId: string,
  data: IUpdateOrderLineAssignmentsDto
) => WashdayClientSingleton.getInstance().orders.updateLineAssignments(orderId, data);

export const updateOrderByIdV2 = async (id: string, data: {
  orderType?: 'standard' | 'return',
  returnSourceOrderId?: string,
  returnItemsChargeMode?: 'no_charge' | 'charge',
  status?: string,
  pinUserId?: string,
  pinValidationToken?: string,
  products?: any[],
  buyAndGetProducts?: any[],
  customer?: string,
  discountCode?: string | null,
  notes?: string,
  privateNotes?: string,
  delivery?: boolean,
  pickup?: boolean,
  express?: boolean,
  deliveryInfo?: {
    date: Date,
    fromTime: string,
    toTime?: string
  },
  pickupInfo?: {
    date: Date,
    fromTime: string,
    toTime?: string
  },
  notifyBy?: string,
  updateMode?: 'store_reception_validation',
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.updateById(id, data);
  } catch (e) {
    throw e;
  }
};

export const createOrderEvidence = async (orderId: string, data: FormData) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.createOrderEvidence(orderId, data);
  } catch (e) {
    console.log('ERROR createOrderEvidence', e);
    throw e;
  }
};
//#endregion


export const getRedeemPointsPreview = async (data: {
  customerId: string,
  storeId: string,
  orderTotal: number
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.getRedeemPointsPreview(data);
  } catch (e) {
    console.log('ERROR getRedeemPointsPreview', e);
    throw e;
  }
};

export const setOrderUncollected = async (data: {
  orderId?: string;
  orderSequence?: string;
  orderStore?: string;
  reason?: 'abandoned' | 'sent_to_warehouse' | 'donated' | 'discarded' | 'other';
}) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.setOrderUncollected(data);
  } catch (e) {
    console.log('ERROR setOrderUncollected', e);
    throw e;
  }
};


export const sendOrderUncollectedCustomerNotification = async (orderId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.sendOrderUncollectedCustomerNotification(orderId);
  } catch (e) {
    console.log('ERROR sendOrderUncollectedCustomerNotification', e);
    throw e;
  }
};

export const updateLineStatuses = async (
  orderId: string,
  updates: Array<{ lineId: string; status: string }>
) => {
  try {
    return await WashdayClientSingleton.getInstance().orders.updateLineStatuses(orderId, { updates });
  } catch (e) {
    console.log('ERROR updateLineStatuses', e);
    throw e;
  }
};

// Keep the store scope explicit for both preview and manual delivery.
export const getOrderNotificationOptions = (orderId: string, storeId: string) =>
  WashdayClientSingleton.getInstance().orders.getNotificationOptions(orderId, { storeId });

export const resendOrderNotification = (orderId: string, data: ResendOrderNotificationRequest) =>
  WashdayClientSingleton.getInstance().orders.resendNotification(orderId, data);
